const blockTitles = document.querySelectorAll('.loc-wrapper');
const blockProducts = document.querySelectorAll('.contact-map');
const locations = document.querySelectorAll('.wrap');

blockTitles.forEach(title => {
  title.addEventListener('click', () => {
    const titleValue = title.value;
    blockProducts.forEach(product => {
      product.style.display = product.id === titleValue ? 'block' : 'none';
    });

    locations.forEach(location => {
      location.style.display = location.id === titleValue ? 'block' : 'none';
    });

    title.classList.add('active');
  });
});
